<template>
 <div class="import-file">
   <sy-upload
     v-loading.fullscreen.lock="loading"
     maxFileSize="5MB"
     :element-loading-text="pageText.loading"
     class="upload-demo"
     ref="fe-upload"
     :action="upload"
     :showFileList="showFileList"
     :before-upload="beforeTextUpload"
     :on-error="handleAvatarError"
     :on-success="uploadTextSuccess">
     <span class="add-files">{{variableReplace(pageText.addFile, {n: 5})}}</span>
   </sy-upload>
   <file-list :fileList="fileList" :isShowDownLoad="false" @delFile="delFile" class="file-list-content"></file-list>
 </div>
</template>

<script>
  import feedbackApi from './api.js'
  import FileList from '../file-list/index.vue'
  import i18n from './i18n.js'
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'import-file',
    props: {
      fileList: {
        type: Array,
        default: () => []
      }
    },
    components: {
      FileList
    },
    data () {
      return {
        pageText,
        loading: false,
        showFileList: false,
        upload: feedbackApi.upload.url
      }
    },
    methods: {
      variableReplace: window.fe.variableReplace,
      // 自定义上传
      beforeTextUpload (file) {
        if (this.fileList.length >= 3) {
          this.$message.warning(this.variableReplace(pageText.acceptFile, {n: 3}))
          return false
        }
        // 限制上传文件为5M
        let sizeIsSatisfy = file.size > 5 * 1024 * 1024
        if (sizeIsSatisfy) {
          this.$message.error(this.variableReplace(pageText.acceptFileSize, {n: 5}))
          return false
        }
        this.loading = true
      },
      // 协议文本上传成功后
      uploadTextSuccess (response) {
        if (response.success) {
          this.$emit('uploadSuccess', response.content)
        } else {
          this.$message.error(response.errorMessage)
        }
        this.loading = false
      },
      handleAvatarError () {
        this.loading = false
      },
      delFile (index) {
        this.$emit('delFile', index)
      }
    }
  }
</script>

<style scoped lang="scss">
  // @import '@/common/css/variable.scss';
  .import-file{
    .upload-demo{
      max-width: 620px;
    }
    .add-files{
      display: inline-block;
      height: 32px;
      line-height: 32px;
      width: 134px;
      text-align: center;
      font-size: 12px;
      color: #666666;
      background: #FFFFFF;
      border: 1px solid #D0D0D0;
      border-radius: 3px;
    }
    .file-list-content{
      margin-top: 16px;
    }
  }
</style>
